import { MetricsChartDataItemPaths } from './metrics-chart.types';

export const dataKeyToLabelMap: Record<Exclude<MetricsChartDataItemPaths, 'date'>, string> = {
  uniqueCodesShared: 'Code Shared',
  newMembersReferred: 'New Members Referred',
};
